export default {
  title: "Fundamentals of Programming",
  subtitle: "Laying the Groundwork for Effective Coding Practices",
  overviewTitle: "Course Overview",
  overview: `<p className="cs-m0">
              This comprehensive course is designed to introduce you to the fundamental principles of programming, serving as a solid foundation for aspiring developers. You will explore core programming concepts such as variables, control structures, data types, and algorithms, which are essential for writing effective code across various programming languages.
            </p>
            <br />
            <p className="cs-m0">
              The curriculum covers popular languages like Python, Java, and JavaScript, allowing you to gain practical experience in coding through hands-on exercises and projects. You will learn how to solve problems using logical thinking and develop algorithms that optimize your code for efficiency and readability.
            </p>
            <br />
            <p className="cs-m0">
              Whether you are a complete beginner or looking to strengthen your existing skills, this course will equip you with the knowledge and confidence needed to tackle more advanced programming concepts and real-world challenges.
            </p>`,
};
